const featureSettings = {
    enable_new_stocks: false,
    enable_return_orders: false,
};

export { featureSettings };
